<template lang="pug">
section.has-background-purple
  .container.p-5
    .columns
      .column.is-one-fifth
        figure.image
          img(src="@/assets/charity.png")
      .column
        .hero
          .hero-body
            .container
              h1.title.has-text-white Donate
              h2.subtitle.has-text-white If you support our work, please consider donating to one of the following charities
              b-button(type="is-white", tag="router-link", to="/charity") Learn More
</template>

<script>
export default {
  name: "CharityCallout"
};
</script>

<style lang="scss">
.p-5 {
  padding: 5rem;
}
</style>
